module.exports = __webpack_public_path__ + "img/image-home-step02.18af3f9c.png";